// const BASE_URL = "http://localhost:4000"
const BASE_URL = "https://bucket-da2i.onrender.com";
export default BASE_URL;